import { render, staticRenderFns } from "./LayoutPartTopConfiguration.vue?vue&type=template&id=77ef4dba"
import script from "./LayoutPartTopConfiguration.vue?vue&type=script&lang=js"
export * from "./LayoutPartTopConfiguration.vue?vue&type=script&lang=js"
import style0 from "./LayoutPartTopConfiguration.vue?vue&type=style&index=0&id=77ef4dba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports